import React from 'react';
import './Fader.css';
import dragPercentage from '../../../utils/dragPercentage';

/**
 * @typedef {Object} FaderProps
 * @property {number} volume - Current volume level (0-1)
 * @property {(volume: number) => void} setVolume - Function to set volume
 * @property {string} name - Display name for the fader
 * @property {boolean} highlightSlider - Whether to highlight the slider
 */

/**
 * @param {FaderProps} props
 */
const Fader = (props) => (
  <div className={'Fader'}>
    <div
      className={'Fader-slider'}
      onMouseDown={dragPercentage(props.setVolume, 'Fader-slider', null, true)}
    >
      <div className={'Fader-slider-channel'}>
        <div
          className={`Fader-slider-fill${
            props.highlightSlider ? ' Fader-slider-fill-highlight' : ''
          }`}
          style={{ height: `${props.volume * 100}%` }}
        />
      </div>
      <div
        className={'Fader-slider-knob'}
        style={{ bottom: `${props.volume * 100}%` }}
      />
    </div>
    <div className={'Fader-slider-name'}>{props.name}</div>
  </div>
);

export default Fader;
